import { create } from "zustand";

const CLOSE_MS = 380;
let closeTimer: ReturnType<typeof setTimeout> | null = null;
const cancelClose = () => {
  if (closeTimer) clearTimeout(closeTimer);
  closeTimer = null;
};

type TRqaSimConfigureStore = {
  isOpen: boolean;
  isClosing: boolean;
  setOpen: (isOpen: boolean) => void;
  dismiss: () => void;
};

export const useRqaSimConfigureStore = create<TRqaSimConfigureStore>((set, get) => ({
  isOpen: false,
  isClosing: false,
  setOpen: (isOpen) => {
    cancelClose();
    if (isOpen) {
      set({ isOpen: true, isClosing: false });
      return;
    }
    if (!get().isOpen) return;
    set({ isClosing: true });
    closeTimer = setTimeout(() => {
      closeTimer = null;
      set({ isOpen: false, isClosing: false });
    }, CLOSE_MS);
  },
  dismiss: () => {
    cancelClose();
    set({ isOpen: false, isClosing: false });
  }
}));
